import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import styles from "./style.css";
import { createClassNames } from "../../../../infrastructure/helpers";

export default class UQFormErrors extends PureComponent {

  static propTypes = {
    errors: PropTypes.string,
    textClass: PropTypes.string
  };

  render() {
    const classNames = createClassNames([styles.errorText, this.props.textClass]);

    return (
      <div className={classNames}>
        {this.props.error}
      </div>
    );
  }
}